<template>
  <el-scrollbar style="width: 100%; overflow-x: hidden;">
    <div class="page">
      <div class="h3-title flex-row flex-main-axis-between" style="margin-top: 0; margin-bottom: 0;">
        <span>独家爆品约量记录</span>
      </div>
      <div class="shadow-box">
        <div class="page-main_box" style="height: auto;">
          <div class="search-box" style="padding-top: 6px;">
            <el-row :gutter="6" type="flex" align="middle">
              <el-col :span="5">
                <div class="search-item">
                  <div class="label">商品名称：</div>
                  <el-input
                    v-model="form.productName"
                    clearable
                    placeholder="请输入商品名称"
                  />
                </div>
              </el-col>
              <el-col :span="5">
                <div class="search-item">
                  <div class="label">下单路径：</div>
                  <el-select
                    v-model="form.salesPathCode"
                    clearable
                    placeholder="请选择"
                    style="width: 100%;"
                  >
                    <el-option
                      v-for="item in salesPathOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </div>
              </el-col>
              <el-col :span="5">
                <div class="search-item">
                  <div class="label">佣金：</div>
                  <el-select
                    v-model="form.commissionType"
                    clearable
                    placeholder="请选择"
                    style="width: 100%;"
                  >
                    <el-option
                      v-for="item in commissionTypeOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="search-item">
                  <div class="label">约量时间：</div>
                  <el-date-picker
                    v-model="form.reserveTimeRange"
                    type="datetimerange"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    range-separator="至"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                    style="width: 100%;"
                  />
                </div>
              </el-col>
              <el-col :span="4">
                <div class="search-item search-btns">
                  <el-button type="primary" @click="goSearch">查询</el-button>
                  <!-- <el-button type="primary" icon="el-icon-plus" @click="handleAdd">新增</el-button> -->
                </div>
              </el-col>
            </el-row>
          </div>

          <div class="tip-line">
            <i class="el-icon-warning"></i>
            提交约量信息后无法更改，可联系商务/运营进行沟通。
          </div>

          <div class="code-list-content">
            <el-table
              border
              stripe
              :data="tableData"
              v-loading="isLoading"
            >
              <el-table-column type="index" label="序号" width="60" />
              <el-table-column prop="productName" label="商品名称" min-width="120" show-overflow-tooltip />
              <el-table-column prop="productMainImage" label="商品图片" width="96">
                <template slot-scope="{ row }">
                  <el-image
                    v-if="row.productMainImage"
                    :src="row.productMainImage"
                    :preview-src-list="[row.productMainImage]"
                    style="width: 64px; height: 64px;"
                    fit="cover"
                  />
                  <img
                    v-else
                    src="../../../../../../../assets/images/default.png"
                    style="width: 64px; height: 64px; object-fit: cover;"
                  />
                </template>
              </el-table-column>
              <el-table-column prop="salesPathName" label="下单路径" min-width="100" />
              <el-table-column label="佣金" min-width="140">
                <template slot-scope="{ row }">
                  {{ formatListCommissionText(row) }}
                </template>
              </el-table-column>
              <el-table-column label="所需库存" min-width="140">
                <template slot-scope="{ row }">
                  {{ formatListReservationText(row) }}
                </template>
              </el-table-column>
              <el-table-column prop="createTime" label="约量时间" min-width="160" />
              <el-table-column prop="expectedOrderTime" label="预期下单时间" min-width="160" />
              <el-table-column label="操作" width="80" fixed="right">
                <template slot-scope="{ row }">
                  <el-button type="text" @click="showDetail(row)">详情</el-button>
                </template>
              </el-table-column>
            </el-table>

            <div class="bd--pag flex-row flex-main-axis-end">
              <el-pagination
                v-if="pageInfo.total > 0"
                class="d-ib"
                background
                layout="total, prev, pager, next, jumper"
                :total="pageInfo.total"
                :page-size="pageInfo.size"
                :current-page="pageInfo.current"
                @current-change="handlePageChange"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <ReserveRecordDetailDialog v-model="showDetailDialog" :record="curRow" />

    <ReserveRecordAddDrawer v-model="showAddDrawer" @success="getList" />
  </el-scrollbar>
</template>

<script>
import ReserveRecordDetailDialog from '@/page/component/sections/xpk/sup/reserve-record-detail-dialog'
import ReserveRecordAddDrawer from '@/page/component/sections/xpk/sup/reserve-record-add-drawer'
import { getQdMyVolumeList } from '@/service/apis/supVolume'
import {
  COMMISSION_TYPE_OPTIONS,
  formatListCommissionText,
  formatListReservationText,
  loadSalesPathOptions
} from '@/page/component/sections/xpk/sup/sup-volume-fields'

export default {
  name: 'SupReserveRecord',
  components: {
    ReserveRecordDetailDialog,
    ReserveRecordAddDrawer
  },
  data() {
    return {
      form: {
        productName: '',
        salesPathCode: '',
        commissionType: '',
        reserveTimeRange: []
      },
      salesPathOptions: [],
      commissionTypeOptions: COMMISSION_TYPE_OPTIONS,
      tableData: [],
      pageInfo: {
        current: 1,
        size: 10,
        total: 0
      },
      isLoading: false,
      showDetailDialog: false,
      showAddDrawer: false,
      curRow: null
    }
  },
  created() {
    this.loadSalesPathOptions()
    this.getList()
  },
  methods: {
    formatListCommissionText,
    formatListReservationText,
    loadSalesPathOptions() {
      loadSalesPathOptions(this).then(list => {
        this.salesPathOptions = list
      })
    },
    getList() {
      this.isLoading = true
      const params = {
        pageIndex: this.pageInfo.current,
        pageSize: this.pageInfo.size
      }
      if (this.form.productName) {
        params.productName = this.form.productName
      }
      if (this.form.salesPathCode) {
        params.salesPathCode = this.form.salesPathCode
      }
      if (this.form.commissionType) {
        params.commissionType = this.form.commissionType
      }
      if (this.form.reserveTimeRange && this.form.reserveTimeRange.length === 2) {
        params.createTimeBegin = this.form.reserveTimeRange[0]
        params.createTimeEnd = this.form.reserveTimeRange[1]
      }
      getQdMyVolumeList.call(this, params).then(res => {
        this.tableData = res.records || []
        this.pageInfo.total = res.total || 0
      }).finally(() => {
        this.isLoading = false
      })
    },
    goSearch() {
      this.pageInfo.current = 1
      this.getList()
    },
    handlePageChange(page) {
      this.pageInfo.current = page
      this.getList()
    },
    showDetail(row) {
      this.curRow = row
      this.showDetailDialog = true
    },
    handleAdd() {
      this.showAddDrawer = true
    }
  }
}
</script>

<style scoped>
.search-btns {
  justify-content: flex-start;
}

.tip-line {
  margin: 12px 0;
  line-height: 20px;
  font-size: 12px;
  color: #f5222d;
}

.tip-line i {
  margin-right: 4px;
}

.bd--pag {
  padding: 16px 0;
}
</style>
